import { Select } from '@chakra-ui/react';
import { projectTypes } from '../../../utils/layoutConfig';

function setProjectType({ e, projectInfo, setProjectInfo }) {
	const value = e.target.value;
	const newProjectInfo = { ...projectInfo };
	newProjectInfo.type = value;
	setProjectInfo(newProjectInfo);
}

const CreateSaveProjectType = ({ projectInfo, setProjectInfo }) => {
	return (
		<Select
			defaultValue={projectInfo.type ? projectInfo.type : ''}
			onChange={(e) => setProjectType({ e, projectInfo, setProjectInfo })}
			size="sm"
			h={8}
		>
			{projectTypes &&
				projectTypes.map((projType, index) => (
					<option key={index} value={projType.value}>
						{projType.name}
					</option>
				))}
		</Select>
	);
};

export default CreateSaveProjectType;
